import React from "react";
import { useTranslation } from "react-i18next";

export default function FloatingParticipantRulesButton({ hidden = false }) {
  const { i18n } = useTranslation("events");
  if (hidden) return null;
  const lang = (i18n.resolvedLanguage || "en").split("-")[0];
  const label = lang === "ru" ? "Правила" : lang === "sk" ? "Pravidlá" : lang === "cs" ? "Pravidla" : "Rules";

  return (
    <button
      id="participant-rating-rules-fab"
      type="button"
      data-bottom-clearance-gap="16"
      onClick={() => {
        window.dispatchEvent(new CustomEvent("vg-participant-rating-rules-open"));
      }}
      className="pointer-events-auto absolute bottom-[86px] left-1/2 z-[6] flex h-[54px] w-full -translate-x-1/2 items-center justify-center rounded-full bg-blue-500 px-6 text-lg font-semibold text-white shadow-[0_18px_36px_rgba(0,115,255,0.28)] transition-transform duration-200 active:scale-[0.985] lg:hidden"
    >
      {label}
    </button>
  );
}
